import { expose } from 'comlink'
import { getWorkbook } from 'core/component/xlsx-utils'
import {
  getColorInfoMapFromList,
  getColorFromColorInfoMap,
  generateGridHeaderForMetaInfo,
  generateMetaInfoMap,
  getHeadersFromMap,
  getFootersFromMap,
} from 'report-dashboard/utils'

export const fillMetaData = (worksheet, headers, data, startRow) => {
  data.forEach((item, rowIndex) => {
    const row = worksheet.getRow(rowIndex + startRow)
    headers.forEach((col, index) => {
      const cell = row.getCell(index + 1)
      const value = item[col.ident]
      if (value) {
        if (value.content) {
          cell.value = value.content
        }
        if (value.color) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {
              argb: 'ff' + value.color,
            },
          }
        }
        cell.font = {
          bold: value.bold,
          size: value.fontSize,
        }
      }
    })
  })
}

const writeToExcel = async worksheets => {
  const workbook = getWorkbook('duke-gads')

  worksheets.forEach((ws, index) => {
    const worksheet = workbook.addWorksheet(ws.name || 'sheet' + (index + 1))
    worksheet.columns = ws.columns.map(item => ({ width: item.width }))

    const metaInfoGridHeaders = generateGridHeaderForMetaInfo(ws.metaInfo)
    const metaInfoMap = generateMetaInfoMap(ws.metaInfo)
    const metaHeaders = getHeadersFromMap(metaInfoMap)

    const metaHeadersCount = metaHeaders.length

    const metaHeaderStartRow = 1
    fillMetaData(
      worksheet,
      metaInfoGridHeaders,
      metaHeaders,
      metaHeaderStartRow
    )

    const headerBackground = ws.headerBackgroundARGB || 'ff85edff'

    const headerRow = metaHeadersCount + 1
    const header = worksheet.getRow(headerRow)
    ws.columns.forEach((col, index) => {
      const cell = header.getCell(index + 1)
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: headerBackground },
      }
      cell.font = { bold: true }
      cell.value = col.header
    })

    const dataCount = ws.data.length
    const colorInfoMap = getColorInfoMapFromList(ws.colorInfo)
    const dataStartRow = headerRow + 1
    ws.data.forEach((item, rowIndex) => {
      const row = worksheet.getRow(rowIndex + dataStartRow)
      ws.columns.forEach((col, index) => {
        const cell = row.getCell(index + 1)
        cell.value = item[col.key]
        const color = getColorFromColorInfoMap(item.row, col.key, colorInfoMap)
        if (color != null) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {
              argb: 'ff' + color,
            },
          }
        }
      })
    })

    const metaFooters = getFootersFromMap(metaInfoMap)
    const footerStartRow = dataStartRow + dataCount + 1
    fillMetaData(worksheet, metaInfoGridHeaders, metaFooters, footerStartRow)
  })

  const data = await workbook.xlsx.writeBuffer()

  var blob = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  return blob
}

const writeToCSV = async ws => {
  const workbook = getWorkbook('fe-analytics')
  const worksheet = workbook.addWorksheet(ws.name)
  worksheet.columns = ws.columns
  worksheet.addRows(ws.data)
  const data = await workbook.csv.writeBuffer()
  var blob = new Blob([data], {
    type: 'text/csv;charset=utf-8',
  })
  return blob
}

expose({ writeToExcel, writeToCSV })
